import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconTags = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#030303"
      d="M2.594 5a2.77 2.77 0 0 0-.425 1.462v4.23c0 .778.335 1.525.93 2.076L14 22.86c-1.088.342-2.297.038-3.105-.71l-8.965-8.3A2.83 2.83 0 0 1 1 11.773V7.545c0-.78.334-1.527.93-2.078.199-.184.423-.34.664-.467"
    />
    <path
      fill="currentColor"
      d="M10.359 2a3.02 3.02 0 0 1 2.133.884l9.633 9.634c.925.924 1.193 2.402.43 3.568a19 19 0 0 1-5.47 5.47c-1.164.762-2.643.494-3.568-.43L3.884 11.49A3.02 3.02 0 0 1 3 9.358V5.017A3.016 3.016 0 0 1 6.017 2zM6.017 4A1.017 1.017 0 0 0 5 5.017v4.341l.005.101c.023.233.126.452.293.618l9.634 9.634c.34.341.782.352 1.057.172l.363-.244a17 17 0 0 0 4.531-4.65c.18-.278.168-.718-.17-1.056l-9.635-9.635a1.02 1.02 0 0 0-.72-.298z"
    />
    <circle cx={8.5} cy={7.5} r={1.5} fill="currentColor" />
  </NcIcon>
);
export { NcIconTags };
